"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouterContext = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var missingContext = () => {
  throw new Error('No router context provider found');
};

var RouterContext = /*#__PURE__*/_react.default.createContext({
  channel: {
    subscribe: missingContext,
    publish: missingContext
  },
  getState: missingContext,
  navigate: missingContext,
  navigateIntent: missingContext,
  navigateUrl: missingContext,
  resolveIntentLink: missingContext,
  resolvePathFromState: missingContext
});

exports.RouterContext = RouterContext;